import instance from '@/common/service/api/Axios';
import { TPromocode } from '../domain/Cart.domain';

export const removePromocode = async (params: TPromocode) => {
    return instance
        .get('/promo-code/remove', { params: { session_id: params.session_id } })
        .then(({ data }) => data);
};
